import createIcon from '../../createIcon';

/**
 * @component @name RestorePage
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgMkg2QzQuOSAyIDQuMDEgMi45IDQuMDEgNEw0IDIwQzQgMjEuMSA0Ljg5IDIyIDUuOTkgMjJIMThDMTkuMSAyMiAyMCAyMS4xIDIwIDIwVjhMMTQgMlpNMTIgMThDOS45NSAxOCA4LjE5IDE2Ljc2IDcuNDIgMTVIOS4xM0M5Ljc2IDE1LjkgMTAuODEgMTYuNSAxMiAxNi41QzEzLjkzIDE2LjUgMTUuNSAxNC45MyAxNS41IDEzQzE1LjUgMTEuMDcgMTMuOTMgOS41IDEyIDkuNUMxMC42NSA5LjUgOS40OCAxMC4yOCA4LjkgMTEuNEwxMC41IDEzSDYuNVY5TDcuOCAxMC4zQzguNjkgOC45MiAxMC4yMyA4IDEyIDhDMTQuNzYgOCAxNyAxMC4yNCAxNyAxM0MxNyAxNS43NiAxNC43NiAxOCAxMiAxOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RestorePage = createIcon('RestorePage', [
  [
    'path',
    {
      d: 'M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM12 18C9.95 18 8.19 16.76 7.42 15H9.13C9.76 15.9 10.81 16.5 12 16.5C13.93 16.5 15.5 14.93 15.5 13C15.5 11.07 13.93 9.5 12 9.5C10.65 9.5 9.48 10.28 8.9 11.4L10.5 13H6.5V9L7.8 10.3C8.69 8.92 10.23 8 12 8C14.76 8 17 10.24 17 13C17 15.76 14.76 18 12 18Z',
      key: '98xg8t',
    },
  ],
]);

export default RestorePage;
